// extracted by mini-css-extract-plugin
export default {"modal":"PK-z","modalOverlay":"QK-z","outfitHeading":"RK-z"};